module.exports = __webpack_public_path__ + "static/img/text.c7c3c4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/text.png
// module id = 4C6X
// module chunks = 1